"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinIcon = void 0;
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var use_places_autocomplete_1 = __importDefault(require("use-places-autocomplete"));
var classnames_1 = __importDefault(require("classnames"));
var store_1 = require("../../app/store");
var searchParamsSlice_1 = require("../../features/searchParams/searchParamsSlice");
var addressGeometries_1 = require("../../helpers/addressGeometries");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var T = 'HOME.SEARCH_FORM';
var MIN_CHARS = 2;
// Same pause as the old search before falling back to OpenStreetMap.
var OSM_FALLBACK_DELAY_MS = 1500;
var OSM_DISTRICT_TYPES = [
    'suburb',
    'neighbourhood',
    'quarter',
    'city_district',
    'borough',
];
// ---------- Google ----------
var getGoogleKind = function (suggestion) {
    var types = suggestion.types;
    if (types.includes('route') || types.includes('street_address')) {
        return 'street';
    }
    if (types.includes('sublocality') ||
        types.includes('sublocality_level_1') ||
        types.includes('neighborhood')) {
        return 'community';
    }
    return 'city';
};
var fromGoogle = function (suggestion) {
    var _a, _b;
    return ({
        id: "g-" + suggestion.place_id,
        kind: getGoogleKind(suggestion),
        mainText: suggestion.structured_formatting.main_text,
        secondaryText: (_a = suggestion.structured_formatting.secondary_text) !== null && _a !== void 0 ? _a : '',
        match: (_b = suggestion.structured_formatting.main_text_matched_substrings) === null || _b === void 0 ? void 0 : _b[0],
        resolve: function () { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, addressGeometries_1.getAddressGeocode(suggestion.description, suggestion)];
                    case 1: return [2 /*return*/, (_a = (_b.sent())) === null || _a === void 0 ? void 0 : _a.selectedPlace];
                }
            });
        }); },
    });
};
// Only streets and settlements; shops, parks, stations etc. are dropped.
var getOsmKind = function (row) {
    if (row.category === 'highway')
        return 'street';
    if (row.category !== 'place' && row.category !== 'boundary')
        return null;
    var type = row.addresstype || row.type || '';
    return OSM_DISTRICT_TYPES.includes(type) ? 'community' : 'city';
};
// Nominatim boundingbox is [minLat, maxLat, minLon, maxLon].
var osmBox = function (row) { return ({
    south: Number(row.boundingbox[0]),
    north: Number(row.boundingbox[1]),
    west: Number(row.boundingbox[2]),
    east: Number(row.boundingbox[3]),
}); };
var findMatch = function (text, query) {
    var offset = text.toLowerCase().indexOf(query.trim().toLowerCase());
    return offset >= 0 ? { offset: offset, length: query.trim().length } : undefined;
};
var HomeAddressSearch = function (_a) {
    var onSelect = _a.onSelect;
    var t = react_i18next_1.useTranslation('common').t;
    var dispatch = store_1.useAppThunkDispatch();
    var _b = react_1.useState(false), isFocused = _b[0], setIsFocused = _b[1];
    var _c = react_1.useState([]), osmRows = _c[0], setOsmRows = _c[1];
    // Same request options as the site's existing autocomplete.
    var _d = use_places_autocomplete_1.default({
        requestOptions: { componentRestrictions: { country: ['am'] } },
        debounce: 300,
    }), value = _d.value, setValue = _d.setValue, clearSuggestions = _d.clearSuggestions, data = _d.suggestions.data;
    // 1. Google found something -> use it, forget the OSM results.
    // 2. Nothing from Google -> after a pause ask OpenStreetMap, like the old search.
    react_1.useEffect(function () {
        if (data.length || value.trim().length < MIN_CHARS) {
            setOsmRows([]);
            return undefined;
        }
        var timer = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
            var rows;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, dispatch(searchParamsSlice_1.getMissingData(value))];
                    case 1:
                        rows = (_a = (_b.sent())) !== null && _a !== void 0 ? _a : [];
                        setOsmRows(rows);
                        return [2 /*return*/];
                }
            });
        }); }, OSM_FALLBACK_DELAY_MS);
        return function () { return clearTimeout(timer); };
    }, [value, data]);
    // Nominatim isn't limited to Armenia in the shared thunk; keep Armenian
    // results only and drop repeated segments of the same street.
    var osmItems = osmRows
        .filter(function (row) { return row.display_name.includes('Հայաստան'); })
        .reduce(function (acc, row) {
        var kind = getOsmKind(row);
        if (!kind)
            return acc;
        var _a = row.display_name.split(', '), mainText = _a[0], rest = _a.slice(1);
        var secondaryText = rest.slice(0, 2).join(', ');
        var isDuplicate = acc.some(function (item) {
            return item.kind === kind &&
                item.mainText === mainText &&
                item.secondaryText === secondaryText;
        });
        if (isDuplicate)
            return acc;
        return acc.concat({
            id: "o-" + row.place_id,
            kind: kind,
            mainText: mainText,
            secondaryText: secondaryText,
            match: findMatch(mainText, value),
            resolve: function () { return __awaiter(void 0, void 0, void 0, function () {
                var details;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, dispatch(searchParamsSlice_1.getMissingDataDetails(row.osm_type.charAt(0).toUpperCase(), String(row.osm_id), row.category))];
                        case 1:
                            details = _a.sent();
                            if (!details)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, __assign(__assign({}, addressGeometries_1.combineMissingDataToOnSelect(row, details)), { main_text: mainText, secondary_text: secondaryText, geometry: osmBox(row) })];
                    }
                });
            }); },
        });
    }, []);
    var items = data.length ? data.map(fromGoogle) : osmItems;
    var pick = function (item) {
        onSelect(item);
        setValue('', false);
        clearSuggestions();
        setOsmRows([]);
    };
    return (react_1.default.createElement(AddressSearchView, { value: value, items: items, isFocused: isFocused, placeholder: t(T + ".PLACE_PLACEHOLDER"), categoryTitle: function (key) { return t(T + "." + key); }, onChange: function (next) { return setValue(next); }, onFocus: function () { return setIsFocused(true); }, onBlur: function () { return setIsFocused(false); }, onPick: pick }));
};
// ---------- view ----------
var iconProps = {
    width: 18,
    height: 18,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
};
var SearchIcon = function () { return (react_1.default.createElement("svg", __assign({}, iconProps, { width: 20, height: 20, strokeWidth: 2 }),
    react_1.default.createElement("circle", { cx: "11", cy: "11", r: "7" }),
    react_1.default.createElement("path", { d: "M20 20l-3.5-3.5" }))); };
var PinIcon = function () { return (react_1.default.createElement("svg", __assign({}, iconProps),
    react_1.default.createElement("path", { d: "M12 21s-6-5.6-6-11a6 6 0 0 1 12 0c0 5.4-6 11-6 11z" }),
    react_1.default.createElement("circle", { cx: "12", cy: "10", r: "2.2" }))); };
exports.PinIcon = PinIcon;
var DistrictIcon = function () { return (react_1.default.createElement("svg", __assign({}, iconProps),
    react_1.default.createElement("path", { d: "M3 7l6-3 6 3 6-3v13l-6 3-6-3-6 3z" }),
    react_1.default.createElement("path", { d: "M9 4v13M15 7v13" }))); };
var CityIcon = function () { return (react_1.default.createElement("svg", __assign({}, iconProps),
    react_1.default.createElement("path", { d: "M4 21V8l6-3v16M10 21V3l10 5v13" }),
    react_1.default.createElement("path", { d: "M2 21h20M14 11h2M14 15h2" }))); };
// Cian order: the most precise category first.
var CATEGORIES = [
    { kind: 'street', titleKey: 'STREETS', Icon: exports.PinIcon },
    { kind: 'community', titleKey: 'DISTRICTS', Icon: DistrictIcon },
    { kind: 'city', titleKey: 'CITIES_AND_VILLAGES', Icon: CityIcon },
];
var highlight = function (item) {
    if (!item.match)
        return item.mainText;
    var start = item.match.offset;
    var end = start + item.match.length;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        item.mainText.slice(0, start),
        react_1.default.createElement("strong", null, item.mainText.slice(start, end)),
        item.mainText.slice(end)));
};
var AddressSearchView = function (_a) {
    var _b;
    var _c, _d;
    var value = _a.value, items = _a.items, isFocused = _a.isFocused, placeholder = _a.placeholder, categoryTitle = _a.categoryTitle, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onPick = _a.onPick;
    var groups = CATEGORIES.map(function (category) { return (__assign(__assign({}, category), { items: items.filter(function (item) { return item.kind === category.kind; }) })); }).filter(function (group) { return group.items.length > 0; });
    var firstId = (_d = (_c = groups[0]) === null || _c === void 0 ? void 0 : _c.items[0]) === null || _d === void 0 ? void 0 : _d.id;
    var isListVisible = isFocused && value.trim().length >= MIN_CHARS && groups.length > 0;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.address },
        react_1.default.createElement("div", { className: classnames_1.default(styles_module_scss_1.default.address_input, (_b = {},
                _b[styles_module_scss_1.default.address_input_focused] = isFocused,
                _b)) },
            react_1.default.createElement(SearchIcon, null),
            react_1.default.createElement("input", { type: "text", value: value, placeholder: placeholder, onChange: function (e) { return onChange(e.target.value); }, onFocus: onFocus, onBlur: onBlur, 
                // Enter picks the highlighted suggestion instead of submitting the form
                onKeyDown: function (e) {
                    var _a;
                    if (e.key !== 'Enter')
                        return;
                    e.preventDefault();
                    var first = (_a = groups[0]) === null || _a === void 0 ? void 0 : _a.items[0];
                    if (first)
                        onPick(first);
                } })),
        isListVisible && (react_1.default.createElement("div", { className: styles_module_scss_1.default.suggestions }, groups.map(function (_a) {
            var kind = _a.kind, titleKey = _a.titleKey, Icon = _a.Icon, list = _a.items;
            return (react_1.default.createElement("div", { key: kind, className: styles_module_scss_1.default.category },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.category_title },
                    react_1.default.createElement(Icon, null),
                    categoryTitle(titleKey)),
                react_1.default.createElement("ul", null, list.map(function (item) {
                    var _a;
                    return (react_1.default.createElement("li", { key: item.id },
                        react_1.default.createElement("button", { type: "button", className: classnames_1.default(styles_module_scss_1.default.suggestion, (_a = {},
                                _a[styles_module_scss_1.default.suggestion_first] = item.id === firstId,
                                _a)), 
                            // mousedown, not click: fires before the
                            // input's blur hides the list
                            onMouseDown: function (e) {
                                e.preventDefault();
                                onPick(item);
                            } },
                            react_1.default.createElement("span", { className: styles_module_scss_1.default.suggestion_main }, highlight(item)),
                            item.secondaryText && (react_1.default.createElement("span", { className: styles_module_scss_1.default.suggestion_secondary }, item.secondaryText)))));
                }))));
        })))));
};
exports.default = HomeAddressSearch;
